import dynamic from 'next/dynamic';

const InspectionVehicleDetails = dynamic(() =>
  import('./InspectionVehicleDetails/InspectionVehicleDetails')
);
const InspectionLastStep = dynamic(() =>
  import('./InspectionLastStep/InspectionLastStep')
);
const InspectionFilters = dynamic(() =>
  import('./InspectionFilters/InspectionFilters')
);

export { InspectionVehicleDetails, InspectionLastStep, InspectionFilters };
